import { FraudStatementSearchRequestQuery } from '@lio/api-types';

export const queryFraudStatementsKeys = {
  search: ['fraud-statement'] as const,
  searchWithParams: (params: FraudStatementSearchRequestQuery) => [...queryFraudStatementsKeys.search, params] as const,
  byId: (id?: string) => [...queryFraudStatementsKeys.search, id] as const,
};
